(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sd-collection-intro"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sd-collection-intro')) {
    customElements.define('sd-collection-intro', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.text = this.querySelector('.sd-collection-intro__text');
        this.button = this.querySelector('button');
        this.mobile = window.matchMedia('(max-width: 767px)');
        this.expanded = false;
        this.onResize = () => this.update();
        this.button.addEventListener('click', () => {
          this.expanded = !this.expanded;
          this.update();
          if (!this.expanded) this.button.scrollIntoView({ block: 'nearest' });
        });
        this.mobile.addEventListener('change', this.onResize);
        this.observer = new ResizeObserver(() => {
          if (this.lastWidth !== this.clientWidth) {
            this.lastWidth = this.clientWidth;
            this.update();
          }
        });
        this.observer.observe(this);
        this.update();
      }
      disconnectedCallback() {
        this.mobile.removeEventListener('change', this.onResize);
        this.observer.disconnect();
        this.initialized = false;
      }
      update() {
        this.removeAttribute('data-collapsed');
        this.button.hidden = true;
        if (!this.mobile.matches) return;
        this.setAttribute('data-collapsed', '');
        const overflows = this.text.scrollHeight > this.text.clientHeight + 2;
        if (!overflows || this.expanded) this.removeAttribute('data-collapsed');
        this.button.hidden = !overflows;
        this.button.setAttribute('aria-expanded', String(this.expanded));
        this.button.textContent = this.expanded ? this.button.dataset.less + ' ↑' : this.button.dataset.more + ' ↓';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
